module.exports = __webpack_public_path__ + "static/media/star.d19afe83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewModal/star.svg
// module id = 326
// module chunks = 0